import { bool, func, string, oneOfType, number, object } from 'prop-types'

const Icon = ({ icon, spanClass = 'is-small', callback, value, label, areaLabel, prop, otherProps = {} }) => {
  if ('' === areaLabel && '' !== label) {
    areaLabel = label
  }

  const runCallback = e => {
    if (value || typeof value === 'boolean') {
      prop ? callback(prop, value) : callback(value)
    } else {
      callback(e)
    }
  }
  return (
    <span className={`icon ${spanClass}`} onClick={callback ? e => runCallback(e) : () => { }} {...otherProps} area-label={areaLabel}>
      <i className={icon} aria-hidden={true} /> {label && <span>{label}</span>}
    </span>
  )
}

Icon.propTypes = {
  areaLabel: string,
  icon: string,
  value: oneOfType([string, bool, number]),
  spanClass: string,
  callback: func,
  label: string,
  otherProps: object,
  prop: string
}

export default Icon
